import Vue from 'vue';
import Vuex, { MutationTree, ActionTree } from 'vuex';
import { User } from '../../../models/user';
import axios from 'axios';

Vue.use(Vuex);

interface State {
    current_user: User;
}

const mutations: MutationTree<State> = {
    setCurrentUser: (currentState, currentUser) => (currentState.current_user = currentUser),
    setApiToken: (currentState, apiToken) => {
        // Update the local storage by hand
        localStorage.removeItem('api_token');
        localStorage.setItem('api_token', apiToken);
        axios.defaults.headers.common.Authorization = 'Bearer '.concat(apiToken);
    },
};

const actions: ActionTree < State, any > = {

};

const getters = {
    currentUser(currentState: State): User {
        return currentState.current_user;
    },
};

const state: State = {
    current_user: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        password: '',
        password_confirmation: '',
    },
};

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

export default module;
